export class TokenList {
    constructor(tokens = []) {
        this.subs = new Set();
        this.tokens = [...new Set(tokens)];
    }
    *[Symbol.iterator]() {
        for (const token of this.tokens) {
            yield token;
        }
    }
    has(token) {
        return this.tokens.includes(token);
    }
    add(token) {
        if (this.has(token)) {
            return;
        }
        this.tokens.push(token);
        this.emit();
    }
    delete(token) {
        const index = this.tokens.indexOf(token);
        if (index === -1) {
            return;
        }
        this.tokens.splice(index, 1);
        this.emit();
    }
    subscribe(sub) {
        if (!this.subs.has(sub)) {
            this.subs.add(sub);
            sub(this);
        }
        return () => this.subs.delete(sub);
    }
    emit() {
        this.subs.forEach(sub => sub(this));
    }
    toJSON() {
        return [...this];
    }
}
